import { CalendarMinusIcon } from './CalendarMinusIcon';

/**
 * author: ButchMonkey
 * id 12439778-1F4B-4498-8716-5BE128D194E1
 * name calendar-minus
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-minus.svg
 * tags
 * - Date / Time 
 */
export const EventMinusIcon = CalendarMinusIcon;
export default EventMinusIcon